import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, forkJoin, of } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import {
  AboutSectionView,
  AboutSocialLink,
  ApiInfo,
} from '../../../../core/models/info-api.models';
import { ImageApiService } from '../../../../core/services/image-api.service';
import { InfoApiService } from '../../../../core/services/info-api.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit, OnDestroy {
  loading = true;
  errorMessage = '';
  info: ApiInfo | null = null;
  logoUrl = 'assets/images/logo.svg';
  sections: AboutSectionView[] = [];
  socialLinks: AboutSocialLink[] = [];

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly infoApi: InfoApiService,
    private readonly imageApi: ImageApiService,
  ) {}

  get companyName(): string {
    return (this.info?.companyName || '').trim() || 'Saarvie';
  }

  get phone(): string {
    return (this.info?.contact || '').trim();
  }

  get email(): string {
    return (this.info?.email || '').trim();
  }

  get usageConditionsUrl(): string {
    const value = (this.info?.usageConditions || '').trim();
    return /^https?:\/\//i.test(value) ? value : '';
  }

  get hasContact(): boolean {
    return !!(this.phone || this.email);
  }

  ngOnInit(): void {
    this.load();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  load(): void {
    this.loading = true;
    this.errorMessage = '';

    forkJoin({
      info: this.infoApi.getCompanyInfo(true),
      logoUrl: this.imageApi
        .getUrlByName('company_logo', this.logoUrl)
        .pipe(catchError(() => of(this.logoUrl))),
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: ({ info, logoUrl }) => {
          this.loading = false;
          this.info = info;
          this.logoUrl = logoUrl || this.logoUrl;
          this.sections = this.infoApi.toVisibleSections(info);
          this.socialLinks = this.infoApi.toSocialLinks(info);

          if (!info) {
            this.errorMessage = 'Aucune information disponible';
          }
        },
        error: () => {
          this.loading = false;
          this.info = null;
          this.errorMessage = 'Impossible de charger les informations.';
        },
      });
  }

  onLogoError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.src = 'assets/images/logo.svg';
  }
}
